(function () {

  'use strict';

  eclipseApp

    .controller('prepaidRefillRedeemVoucherCtrl', ['$scope', '$rootScope', '$state', 'uteEndpoint', '$http', 'httpService', 'prepaidAutoRefillInfoService', 'prepaidPlanInfoService', 'prepaidRefillRedeemVoucherService', 'prepaidUserInfoService', 'prepaidAirtimeBalanceService', '$stateParams', '$previousState', 'uteLocale', '$sessionStorage', 'retrievePrepaidPlanInfo', function ($scope, $rootScope, $state, uteEndpoint, $http, httpService, prepaidAutoRefillInfoService, prepaidPlanInfoService, prepaidRefillRedeemVoucherService, prepaidUserInfoService, prepaidAirtimeBalanceService, $stateParams, $previousState, uteLocale, $sessionStorage, retrievePrepaidPlanInfo) {

      $scope.planTitle = prepaidPlanInfoService.getAirTimePlanTitle();
      $scope.planFeatures = prepaidPlanInfoService.getAirTimePlanFeatures();
      $scope.language = uteLocale.language;
      $scope.$storage = $sessionStorage;

      if(prepaidUserInfoService.getCTN() !== null && prepaidUserInfoService.getCTN() !== '' && prepaidUserInfoService.getBAN() !== null && prepaidUserInfoService.getBAN() !== '') {
        $scope.ctn = prepaidUserInfoService.getCTN();
        $scope.ban = prepaidUserInfoService.getBAN();
      }else{
        $scope.ctn = $scope.$storage.selectedCTN;
        $scope.ban = $scope.$storage.selectedBAN;
      }

      var storeURL='';
      if($scope.language ==='en' || $scope.language === 'EN'){
        storeURL = 'https://www.fido.ca/consumer/storelocator';
      }
      else{
        storeURL = 'https://www.fido.ca/consumer/storelocator?setLanguage=fr';
      }

      $scope.init = function () {
        console.log('prepaidRefillRedeemVoucherCtrl');
        $scope.voucher = prepaidRefillRedeemVoucherService.getVoucher();
        if (($scope.voucher !== null)) {
          var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
          var firstDate = new Date($scope.voucher.refillDate);
          var secondDate = new Date($scope.voucher.expiryDate);

          $scope.diffDays = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / (oneDay)));
        }
        $scope.isVoucherReview = true;
        $scope.stopAutoPaymentNotifier = '';

        /*if (angular.isDefined($previousState.get().state.name) && $previousState.get().state.name !== '' && $previousState.get().state.name !== null && $previousState.get().state.name === 'myAccount.prepaidRefill.redeemVoucher-review') {
          $scope.voucherNumber = prepaidRefillRedeemVoucherService.getVoucher().voucherNumber;
        }*/
        if (angular.isDefined($rootScope.previousState) && $rootScope.previousState.name !== '' && $rootScope.previousState.name !== null && $rootScope.previousState.name === 'myAccount.prepaidRefill.redeemVoucher-review') {
          $scope.voucherNumber = prepaidRefillRedeemVoucherService.getVoucher().voucherNumber;
        }
      };

      $scope.autoRefillSubscribed = 'false';

      $scope.fidoStore = function(){
        window.open(storeURL,'_blank').focus();
      };

      /**
       *
       * @param state
       */
      $scope.go = function (state) {
        $state.go(state);
      };


      $scope.voucherCheckRule = {
        voucherNumber: {
          type: 'number',
          pattern: '^[0-9]{14}$',
          required: true
        }
      };

      $scope.continue = function () {
        if ($scope.voucherRefillForm.$valid) {
          var promise = httpService.send(
            'v1/refill/voucher/details', // TODO : Need to change
            {
              accountNumber: prepaidUserInfoService.getBAN(),
              ctn: prepaidUserInfoService.getCTN(),
              voucherNumber: $scope.voucherNumber
            });

          promise.then(
            function (result) {
              if (result.data.error || result.data.status == 'Failed') {
                $scope.voucherDetailsInfoError = true;
                $scope.voucherRefillForm.voucherNumber.$touched = true;
                $scope.voucherRefillForm.voucherNumber.$error.customFieldError = true;
              } else {
                prepaidRefillRedeemVoucherService.setVoucher(result.data);
                $state.go('myAccount.prepaidRefill.redeemVoucher-review');
              }

            },
            function (reason) {
              $scope.voucherDetailsInfoError = true;
              $scope.voucherRefillForm.voucherNumber.$touched = true;
              $scope.voucherRefillForm.voucherNumber.$error.customFieldError = true;
            }
          );
        } else {
          $scope.voucherRefillForm.voucherNumber.$touched = true;
        }

      };

      $scope.getPlanAndAddOnInfo = function (accountNumber, subscriberNumber, language) {
        var promise = httpService.send(
          'v1/wireless/prepaid/dashboard/plan', // TODO : Need to change
          {
            accountNumber: accountNumber,
            ctn: subscriberNumber,
            language: language
          });

        promise.then(
          function (result) {
            if (result.data.error || result.data.status == 'Failed') {
              $scope.planAndAddOnInfoError = true;
            } else {
              //alert('Got PlanAndAddOnInfo Successfully');
              $scope.planAndAddOnInfo = result.data;
              console.log('$scope.planAndAddOnInfo :: ' + $scope.planAndAddOnInfo);
              prepaidAirtimeBalanceService.setAirTimeBalance($scope.planAndAddOnInfo.airtimeBalance);
              prepaidAirtimeBalanceService.setExpiryDate($scope.planAndAddOnInfo.expiryDate);
              prepaidPlanInfoService.setAirTimePlanFee($scope.planAndAddOnInfo.pricePlan);
              $scope.pricePlanInfo = null;
              if (result.data.planDetailsInfo != null) {
                if ($scope.language === 'en' || $scope.language === 'EN') {
                  $scope.pricePlanInfo = result.data.planDetailsInfo.en;
                } else {
                  $scope.pricePlanInfo = result.data.planDetailsInfo.fr;
                }
                if (result.data.planDetailsInfo.productId != null && result.data.planDetailsInfo.productId != '') {
                  prepaidPlanInfoService.setAirTimePlanSoc(result.data.planDetailsInfo.productId);
                } else {
                  prepaidPlanInfoService.setAirTimePlanSoc($scope.planAndAddOnInfo.planSoc);
                }
                if ($scope.pricePlanInfo != null && $scope.pricePlanInfo.planComparison != null && $scope.pricePlanInfo.planComparison.planTitle != null && $scope.pricePlanInfo.planComparison.planTitle != '') {
                  prepaidPlanInfoService.setAirTimePlanTitle($scope.pricePlanInfo.planComparison.planTitle);
                } else {
                  if ($scope.language === 'en' || $scope.language === 'EN') {
                    prepaidPlanInfoService.setAirTimePlanTitle($scope.planAndAddOnInfo.description);
                  } else {
                    prepaidPlanInfoService.setAirTimePlanTitle($scope.planAndAddOnInfo.descriptionFr);
                  }
                }
              } else {
                if ($scope.language === 'en' || $scope.language === 'EN') {
                  prepaidPlanInfoService.setAirTimePlanTitle($scope.planAndAddOnInfo.description);
                } else {
                  prepaidPlanInfoService.setAirTimePlanTitle($scope.planAndAddOnInfo.descriptionFr);
                }
                prepaidPlanInfoService.setAirTimePlanSoc($scope.planAndAddOnInfo.planSoc);
              }
              $scope.planDesc = prepaidPlanInfoService.getAirTimePlanTitle();
              prepaidPlanInfoService.setAirTimePlanFeatures($scope.pricePlanInfo);
              $scope.isVoucherReview = false;
              $scope.airtimeBalance = prepaidAirtimeBalanceService.getAirTimeBalance();
              $scope.balanceExpiryDate = prepaidAirtimeBalanceService.getExpiryDate();
              $scope.clearSharedPropertyService();
            }
          },
          function (reason) {
            $scope.planAndAddOnInfoError = true;
          }
        );
      };

      $scope.redeem = function () {

        var promise = httpService.send(
          'v1/refill/voucher/redeem', // TODO : Need to change
          {
            accountNumber: prepaidUserInfoService.getBAN(),
            ctn: prepaidUserInfoService.getCTN(),
            voucherNumber: parseInt(prepaidRefillRedeemVoucherService.getVoucher().voucherNumber)
          });

        promise.then(
          function (result) {
            if (result.data.error || result.data.status == 'Failed') {
              $scope.voucherRedeemInfoError = true;
            } else {
              //$scope.isVoucherReview = false;
              $scope.getPlanAndAddOnInfo(prepaidUserInfoService.getBAN(), prepaidUserInfoService.getCTN(), $scope.language);
            }
          },
          function (reason) {
            $scope.voucherRedeemInfoError = true;
          }
        );

      };

      $scope.clearSharedPropertyService = function () {
        prepaidRefillRedeemVoucherService.setVoucher(null);
      };

      $scope.backToDashboard = function () {
        $scope.clearSharedPropertyService();
        $state.go('myAccount.prepaidWLDashboard', { 'accountNumber': $scope.ban, 'subscriberNo': $scope.ctn });
      };

      /**
       * tabs data for ui tabs directive
       * @type {{heading: string, subheading: string, route: string}[]}
       */

      $scope.tabData = [{
        heading: 'wireless.label.setUpAutoPayPlan',
        route: 'myAccount.prepaidRefill.autoPayPlan',
        autoRefillSubscribed: 'false',
        content: prepaidAutoRefillInfoService.getAutoPayPlanSubContent(),
        class: 'tab pp-refill-margin-top-1-5'
      }, {
        heading: 'wireless.label.setUpAutoRefillBalance',
        route: 'myAccount.prepaidRefill.autoRefillBalance',
        autoRefillSubscribed: 'false',
        content: prepaidAutoRefillInfoService.getAutoRefillBalanceSubContent(),
        class: 'tab pp-refill-margin-top-1-5'
      }, {
        heading: 'wireless.label.oneTimeRefill',
        route: 'myAccount.prepaidRefill.oneTimeRefill',
        class: 'tab pp-refill-margin-top-1-5'

      }, {
        heading: 'wireless.label.redeemVoucher',
        route: 'myAccount.prepaidRefill.redeemVoucher',
        autoRefillSubscribed: 'false',
        active: true,
        class: 'tab pp-refill-margin-top-1-5'
      }];

      $scope.mobileTabData = [{
        heading: 'wireless.label.redeemVoucher',
        route: 'myAccount.prepaidRefill.redeemVoucher',
        autoRefillSubscribed: 'false',
        active: true,
        class: 'tab pp-refill-margin-top-1-5'
      }];

      $scope.init();

    }]);

})();
